import CategoryModel from "../sdk/CategoryModel"
import _ from "lodash"

export default class CategoryModelMags extends CategoryModel {
  constructor(data) {
    super( data )
    let shop      = window.shop
    let blacklist = shop.config.blacklist
    let langCode  = shop.session && shop.session.value && shop.session.value.country
    langCode      = langCode && langCode.trim()
    this.regionBlocker( langCode, blacklist )
  }

  // BLOCK ARTICLE IF IT'S IN THE BLACKLIST
  regionBlocker(langCode, blacklist) {
    // console.log( `catthis`, this, {langCode, blacklist} )
    if ( !blacklist || !langCode ) return
    let applicableList = blacklist[ langCode ]
    if ( _.includes( applicableList, this.desc.short_des ) ) {
      this.invalid = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/shop/CategoryModelMags.js